import { Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { listCategories } from '../repository';
import { KC_COLORS } from '../theme';
import { KcIcon } from './KcIcon';

export function ExploreCategories() {
  const categories = listCategories();

  return (
    <Box id="kc-categories" className="kc-categories w-full bg-white py-8 md:py-10 scroll-mt-28">
      <Container maxWidth="lg">
        <div className="flex items-center justify-between gap-4 mb-5 md:mb-6">
          <h2 className="kc-section-title kc-type-h3 uppercase tracking-[0.08em]">
            Explore All Categories
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-3.5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.path}
              className="kc-category-card group flex flex-col items-center text-center gap-2.5 rounded-2xl border bg-white px-3 pt-5 pb-4 md:px-4 md:pt-5 md:pb-4 h-[168px] md:h-[188px] shadow-[0_10px_28px_rgba(10,29,58,0.14)] transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(10,29,58,0.22)]"
              style={{ borderColor: KC_COLORS.border }}
            >
              <span
                className="inline-flex shrink-0 items-center justify-center h-12 md:h-14 transition-transform duration-300 group-hover:scale-110"
                style={{ color: KC_COLORS.teal }}
              >
                <KcIcon
                  name={category.icon}
                  fontSize="large"
                  sx={{ fontSize: { xs: 42, md: 48 } }}
                />
              </span>
              <span
                className="kc-type-body font-semibold line-clamp-3"
                style={{ color: KC_COLORS.primaryNavy }}
              >
                {category.longTitle}
              </span>
              <span
                className="shrink-0 kc-type-caption"
                style={{ color: KC_COLORS.teal, fontWeight: 700 }}
              >
                {category.articleCount}
              </span>
            </Link>
          ))}
        </div>
      </Container>
    </Box>
  );
}
